import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ServiceProvider } from "../../../interfaces/ServiceProvidersInterface";
import { RootState } from "../../../store";
import dispatchNotification from "../actions/dispatchNotification";
import { commonErrorMessage } from "../../../helpers/messages";
import getServiceProviders from "../services/serviceproviders";

const useRcSps = (): { rcSps: ServiceProvider[]; isLoading: boolean } => {
  const branch = useSelector((state: RootState) => state.clientPortalUserInfo.selectedBranch);
  const [rcSps, setRcSps] = React.useState<ServiceProvider[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const dispatch = useDispatch();
  const getRcSps = useCallback(async () => {
    try {
      setIsLoading(true);
      const rSps = await getServiceProviders(branch?.id);
      setRcSps(rSps);
    } catch (error) {
      dispatchNotification.error(dispatch, commonErrorMessage);
    } finally {
      setIsLoading(false);
    }
  }, [branch?.id, dispatch]);

  React.useEffect(() => {
    if (branch?.id) {
      getRcSps();
    }
  }, [branch?.id, getRcSps]);
  return { rcSps, isLoading };
};

export default useRcSps;
